import React, { useState, useEffect } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import Profile from '../../components/profile';
import LoadingScreen from '../../components/LoadingScreen';
import ButtonLogReg from '../../components/ButtonLogReg';
import Notification from '../../components/Notification';
import Trolly from '../../components/Trolly';
import { useCookies } from 'react-cookie';
import { useNavigate, useParams } from 'react-router';

export default function ShopPage() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [seller, setSeller] = useState({});
  const [cookies, setCookie] = useCookies(['accessToken']);
  const [Data, setData] = useState([])

  const [user, setUser] = React.useState({});
  const navigate = useNavigate();

  React.useEffect(() => {
    const validateAccessToken = async () => {
      try {
        const url = 'https://w-shop-backend.vercel.app/api/auth/whoami';
        const rawResponse = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + cookies.accessToken,
          },
        })
        const response = await rawResponse.json();
        if (response.status !== 'success') {
          throw new Error();
        } else {
          setUser(response.data);
        }
      } catch (error) {
        setUser('')
      }
    }
    validateAccessToken();

  }, [cookies.accessToken, setCookie, navigate])

  let logReg
  let mB
  let notification
  let trolly
  if (user.role === 'buyer') {
    logReg = <Profile userData={user} />
    mB = ''
    trolly = <Trolly />
    notification = <Notification />
  } else {
    logReg = <ButtonLogReg />
    mB = <a href="/sellerLogin" className="navbar-top">Mulai Berjualan  |</a>
  }

  const rupiah = (number) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR"
    }).format(number);
  }

  useEffect(() => {
    const getSellerData = async () => {
      try {
        const url = 'https://w-shop-backend.vercel.app/api/sellers/' + id;
        const response = await fetch(url, {
          method: 'GET'
        });
        const body = await response.json();
        if (body.status !== 'success') {
          throw new Error(body.message);
        } else {
          setSeller(body.data)
        }
      } catch (error) {
        setSeller({});
      }
    }
    
    const fetchProduct = async () => {
      setIsLoading(true);
      let url = 'https://w-shop-backend.vercel.app/api/products?idSeller=' + id
      fetch(url, {
        method: 'GET',
      })
        .then((response) => response.json())
        .then((body) => {
          const product = body.data;
          product.sort((a, b) => a.id - b.id);
          setData(product);
          setTimeout(() => {
            setIsLoading(false);
          }, 500)
        })
        .catch(error => {
          console.error(error);
        });
    }
    getSellerData();
    fetchProduct();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  }, [id])

  return (
    <>
      <LoadingScreen active={isLoading} />
      <Navbar userData={setUser} logReg={logReg} mb={mB} notification={notification} trolly={trolly} />
      <div className='container'>
        <div className="row py-5">
          <div className="col-md-6 border-end">
            <div className="px-5 pt-4 my-1 d-flex" style={{
              backgroundColor: '#ffffff',
              backgroundImage: 'linear-gradient(315deg, #ffffff 0%, #5899e2 74%)', maxWidth: "528px", height: "219px",
              borderRadius: "30px"
            }}>
              <img alt="" src={seller.imgUrl} style={{ width: 135, height: 135, borderRadius: 100 }} />
              <h1 className="sn mt-5 ms-3">{seller.shopName}</h1>
            </div>
          </div>
          <div className="col-md-6">
            <p className="ds mt-1 ps-3">p{seller.description}</p>
          </div>
        </div> <hr />
        <h1>Daftar Produk</h1><hr />
        <div className="row mt-5" style={{ minHeight: "500px" }}>
          {
            Data.map((items) => (
              <div className="col" key={items.id}>
                <a href={'/search/detailSearch/' + items.id} className="card mb-5" style={{ width: "216px", height: "319px", textDecoration: "none" }}
                  onClick={() => {
                  }}
                >
                  <img src={items.imgUrl} className="card-img-top border-bottom" alt="..." style={{ height: "216px" }} />
                  <div className="card-body">
                    <h6 className='cardTitle'>{items.product}</h6>
                    <h6 className='cardPrice'>{rupiah(items.price)}</h6>
                    <h6 className='cardProvince'>{items.seller.address}</h6>
                  </div>
                </a>
              </div>
            ))
          }
        </div>
      </div>
      <Footer />
    </>
  );
}
